import React from 'react';

import { GenerateThumbnailObject } from 'src/utils/ConsumptionHelper/ConsumptionHelper';
import { ContentMetaData } from 'src/utils/ConsumptionHelper/types';
import { getDeviceWidth } from 'src/utils/getDeviceWidth';
import { IMAGE_PATH_AND_NAME } from 'src/utils/ImageHelper/ImagePathHelper';
import { getImageURL } from 'src/utils/ImageHelper/ImageURLGenerator';

import * as customStyled from './RailsStyle';
import BannerCarouselTray from '../Carousel/BannerCarousel';
import ThumbnailComponent from '../thumbnail';
import { ThumbnailTypes } from '../thumbnail/types';

interface BellyBannerRailProps {
  showTitle: boolean;
  contents: any;
  title: string;
  tagName: keyof typeof IMAGE_PATH_AND_NAME;
  moreLink: string;
  verticalIndex: number;
}

const BellyBannerRail: React.FC<BellyBannerRailProps> = ({
  contents,
  tagName,
  title,
  verticalIndex
}) => {
  const renderThumbnails = (
    thumbnails: ContentMetaData[],
    tagName: keyof typeof IMAGE_PATH_AND_NAME,
    verticalIndex: number,
    title?: string
  ) => {
    return thumbnails.map((content: ContentMetaData, index: number) => {
      if (!Object.keys(content).length) return <></>;
      const generateThumbnailInstance: GenerateThumbnailObject =
        GenerateThumbnailObject.getThumbnailInstance(
          ThumbnailTypes.bellybanner,
          tagName,
          {
            content,
            hoverOut: true,
            displayTitleOnImage: false
          }
        );
      const generateThumbnailObject = generateThumbnailInstance.generate();
      const imageURL = getImageURL({
        tagName: generateThumbnailObject.tagName,
        deviceWidth: getDeviceWidth() || 0,
        item: {
          id: content.id,
          title: content.title,
          assetType: content.assetType,
          image: content.image
        }
      });
      const cardDetails = {
        contentId: content.id,
        title: title || '',
        horizontalIndex: index + 1,
        verticalIndex: verticalIndex + 1,
        assetSubtype: content.assetSubType,
        originalTitle: content.originalTitle
      };
      return (
        <ThumbnailComponent
          key={generateThumbnailObject.contentId}
          {...generateThumbnailObject}
          imageUrl={imageURL}
          cardDetails={cardDetails}
        />
      );
    });
  };

  return (
    <React.Fragment>
      {contents?.length ? (
        <BannerCarouselTray contentCount={contents.length}>
          <div css={customStyled.railsContainer('flex')} key={verticalIndex}>
            {renderThumbnails(contents, tagName, verticalIndex, title)}
          </div>
        </BannerCarouselTray>
      ) : null}
    </React.Fragment>
  );
};

export default React.memo(BellyBannerRail);
